import React from 'react';
import ReactDOM from 'react-dom';
import AppWrapper from './ui/AppWrapper';
import { unregister } from './serviceWorker';
import './index.css';

ReactDOM.render(
  <React.StrictMode>
    <AppWrapper />
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
unregister();
